import React from 'react';
import { InitialDependenciesError } from '../../../../api/frontendStartup/types';
import { GraphQlRequestErrorCode } from '../../../../api/types';
import { GraphQLError, NetworkError } from '../../../errors';
import InsufficientPermissionsErrorComponent from './InsufficientPermisionsErrorComponent';
import IpForbiddenErrorComponent from './IpForbiddenError';
import NetworkErrorComponent from './NetworkError';
import NoAccountRegisteredErrorComponent from './NoAccountRegisteredError';
import SetupErrorComponent from './SetupError';
import SomethingWentWrongError from './SomethingWentWrongError';
import WrongAuthMethodErrorComponent from './WrongAuthMethodError';

interface FallbackComponentProps {
  error: Error;
  resetError: () => void;
}

const FallbackComponent = (props: FallbackComponentProps) => {
  const { error, resetError } = props;

  let graphQlError: GraphQLError | null = null;
  if (error instanceof GraphQLError) {
    graphQlError = error;
  } else if (error instanceof InitialDependenciesError) {
    graphQlError = error.underlyingError;
  }
  if (graphQlError) {
    switch (graphQlError.errorCode) {
      case GraphQlRequestErrorCode.Err_UserNotFound:
        return <NoAccountRegisteredErrorComponent />;
      case GraphQlRequestErrorCode.Err_DomainAccessDeniedWrongAuthMethod:
        return <WrongAuthMethodErrorComponent />;
      case GraphQlRequestErrorCode.Err_AuthorizationDenied:
        return (
          <InsufficientPermissionsErrorComponent resetError={resetError} />
        );
      case GraphQlRequestErrorCode.Err_DomainAccessDeniedIpForbidden:
        return <IpForbiddenErrorComponent />;
      default:
        return <SetupErrorComponent />;
    }
  }

  if (error instanceof NetworkError) {
    return <NetworkErrorComponent />;
  }

  // return <NetworkError />;

  return <SomethingWentWrongError error={error} />;
};

export default FallbackComponent;
